import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Input, Space } from '@bedrock/components';
import { ProFilter } from '@bedrock/eed-react';
import { ProFilterProps } from '@bedrock/eed-react/lib/components/ProFilter/interface';
import styles from './index.less';
import classNames from 'classnames/bind';
import { useMemoizedFn } from 'ahooks';
import { FilterConfigItem } from '../../KOLTable/useFilterConfig';

const cx = classNames.bind(styles);

export type SearchFilterBarProps = {
  filterConfig: FilterConfigItem[];
  onChange: (params: any) => void;
} & ProFilterProps

const SearchFilterBar = forwardRef((props: SearchFilterBarProps, ref) => {
  const {
    filterConfig,
    onChange,
    ...restProps
  } = props;
  const [searchText, setSearchText] = useState<string>('');
  const filterRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    ...filterRef.current,
    resetFilter: () => {
      filterRef.current?.reset();
      setSearchText('');
    },
    setFieldValue: (key: string, value: any) => {
      filterRef.current?.setFieldsValue({ [key]: value });
    }
  }));

  const fieldOptions = useMemo(() => {
    return filterConfig
      .filter((item) => item.visible && item.type)
      .map((item) => ({
        name: item.label,
        value: item.key,
        type: item.type,
        showCondition: false,
        filterComponentProps: item.filterComponentProps,
      }));
  }, [filterConfig]);

  const onSearch = useMemoizedFn((groups: any) => {
    const params: any = {};
    groups.forEach((item: any) => {
      params[item.value] = item.filterValue;
    });
    onChange({ ...params, search_text: searchText });
  });

  return (
    <div
      className={cx(
        'mb-[12px] ',
        'filter-without-label'
      )}
    >
      <ProFilter
        ref={filterRef}
        fieldOptions={fieldOptions}
        onSearch={onSearch}
        addonBefore={
          <Input.Search
            placeholder="主平台链接/主平台发布账号"
            value={searchText}
            key="search_text"
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            onSearch={(value, e) => {
              setSearchText(value);
              onChange({ search_text: value });
              e.stopPropagation();
              e.preventDefault();
            }}
            onBlur={(e) => {
              setSearchText(e.target.value);
              onChange({ search_text: e.target.value });
            }}
          />
        }
        onReset={(e) => {
          setSearchText('');
          setTimeout(() => {
            onSearch(e);
          }, 0);
        }}
        {...restProps}
      >
        <Space direction="vertical" size={12}>
          <ProFilter.FilterGroup />
        </Space>
      </ProFilter>
    </div>
  );
});

export default SearchFilterBar;
